import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { Layout, Title, FormError } from 'common/components/layout';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import SubMenu from 'profile/common/SubMenu';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';
import {
  getCustomerAddress,
  editCustomerAddress,
  deleteCustomerAddress
} from 'redux/customerAddresses/actions';

import AddEditForm from './components/AddEditForm';
import ClubMembershipAddressVerify from './components/ClubMembershipAddressVerify';
import { isClubMembershipsWithoutThisAddress } from './helpers';
import { validateEdit } from './validators';

class AddressEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null
    };
  }

  componentDidMount() {
    const { props } = this;
    const { id } = props.match.params;
    props.getCustomerAddress(id);
    props.listClubMemberships();
  }

  handleClubMembershipAddressVerify = () => {
    this.setState({
      modal: 'ClubMembershipAddressVerify'
    });
  };

  handleSubmit = (form) => {
    const { props } = this;
    const { id } = props.match.params;
    const data = transformData(form);
    const { activeClubMemberships } = this.props;
    let successFunction = () => {
      props.history.push('/profile/address-book');
    };
    if (isClubMembershipsWithoutThisAddress(id, activeClubMemberships)) {
      successFunction = () => {
        this.handleClubMembershipAddressVerify();
      };
    }
    props.editCustomerAddress(id, data, successFunction);
  };

  handleCancel = () => {
    const { props } = this;
    props.history.push('/profile/address-book');
  };

  handleDelete = (e) => {
    e.preventDefault();
    const { props } = this;
    const { id } = props.match.params;
    const successFunction = () => {
      props.history.push('/profile/address-book');
    };
    props.deleteCustomerAddress(id, successFunction);
  };

  handleCloseModal = () => {
    const { props } = this;
    this.setState({
      modal: null
    });
    props.history.push('/profile/address-book');
  };

  render() {
    const { settings, customerAddresses, form, match } = this.props;
    const { id } = match.params;
    const { modal } = this.state;
    if (!settings.data || !customerAddresses.data) {
      return (
        <Layout title="Edit Address Book Entry" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    const { handleSubmit, object, change } = this.props;

    const addressArr = Object.keys(customerAddresses.data);
    const isFirstAddress = addressArr.length === 1 || false;

    return (
      <Layout title="Edit Address Book Entry">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__address-book">
          <h2>Edit address book entry</h2>

          <FormError formName={form} />
          <AddEditForm
            onSubmit={handleSubmit(this.handleSubmit)}
            saveButtonText="Update Address"
            object={object}
            changeFunction={change}
            onCancelFunction={this.handleCancel}
            isFirstAddress={isFirstAddress}
            settings={settings}
          />

          <div className="c7-account-row c7-account-row--delete">
            <a onClick={this.handleDelete}>Delete this address</a>
          </div>
        </div>
        {renderModal(modal, this.handleCloseModal, id)}
      </Layout>
    );
  }
}

const renderModal = (modal, handleCloseModal, addressId) => {
  switch (modal) {
    case 'ClubMembershipAddressVerify': {
      return (
        <ClubMembershipAddressVerify
          onCloseModal={handleCloseModal}
          addressId={addressId}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const transformData = (values) => {
  const data = transformAddressData(values);
  data.isDefault = values.isDefault || false;
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  let errors = {};
  if (ownProps.settings && ownProps.settings.data) {
    errors = validateEdit(data, ownProps.settings);
  }
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  let formValues = {};
  if (state.customerAddress.data) {
    const address = state.customerAddress.data[ownProps.match.params.id];
    formValues = initialFormValues(address);
  }
  return {
    initialValues: formValues,
    object:
      state.customerAddress.data &&
      state.customerAddress.data[ownProps.match.params.id],
    isFetching: state.customerAddress.isFetching,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    activeClubMemberships: getActiveClubMemberships(state.clubMembership)
  };
};

AddressEdit = reduxForm({
  form: 'Edit Address',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(AddressEdit);

export default connect(mapStateToProps, {
  getCustomerAddress,
  editCustomerAddress,
  deleteCustomerAddress,
  listClubMemberships
})(AddressEdit);
